<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-card-title>
            <span class="headl">LECTURA MASIVA</span>
          </v-card-title>
          <v-card-text>
            <v-stepper v-model="stepReading" class="mt-6">
              <v-stepper-header>
                <v-stepper-step
                  :complete="stepReading > 1"
                  step="1"
                >
                  Buscar Dispositivos
                </v-stepper-step>
                <v-stepper-step step="2" >
                  Realizar lecturas
                </v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">
                  <v-form
                    ref="form"
                    v-model="valid"
                    method="post"
                    enctype="multipart/form-data"
                    lazy-validation
                  >
                    <v-row>
                      <v-col cols="12" sm="6" md="6">
                        <v-combobox
                          ref="company"
                          v-model="form.company"
                          :items="itemsCompany"
                          :search-input.sync="search"
                          item-value="_id"
                          item-text="name"
                          label="Empresa"
                          placeholder="Digite el nombre de la empresa"
                          :disabled="isMaster == 0"
                          @input="clearLists"
                          clearable
                          :rules="nameRules"
                        ></v-combobox>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-select
                          ref="subTypeService"
                          v-model="form.subTypeService"
                          :items="['Agua', 'Gas', 'Energia']"
                          label="Tipo"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          ref="social"
                          v-model="form.socialgroup"
                          :items="socialSelect"
                          :search-input.sync="searchSocial"
                          item-value="_id"
                          item-text="name"
                          label="Estrato"
                          placeholder="selecciona el estrato"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          ref="zone"
                          v-model="form.zone"
                          :items="zoneSelect"
                          :search-input.sync="searchZone"
                          item-value="_id"
                          item-text="name"
                          label="Zona"
                          placeholder="selecciona la zona"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          ref="road"
                          v-model="form.road"
                          :items="roadSelect"
                          :search-input.sync="searchRoad"
                          item-value="_id"
                          item-text="name"
                          label="Ruta"
                          placeholder="selecciona la ruta"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          ref="cycle"
                          v-model="form.cycle"
                          :items="cycleSelect"
                          :search-input.sync="searchCycle"
                          item-value="_id"
                          item-text="name"
                          label="Ciclo"
                          @change="defaultDate"
                          placeholder="selecciona el ciclo"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
                <v-stepper-content step="2">
                  <v-form
                    ref="form2"
                    v-model="valid2"
                    method="post"
                    enctype="multipart/form-data"
                    lazy-validation
                  >
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <div class="ctn_take_read px-5">
                          <div class="take_read_colum">
                            <div class="copy_read_colum">
                              <h2>DISPOSITIVOS</h2>
                            </div>
                          </div>
                          <div class="take_read_colum">
                            <div class="copy_read_colum">
                              <h3>
                                {{ DeviceNumber }}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0 mb-2">
                      <v-col
                        cols="12"
                      >
                        <v-container class="pl-4" fluid v-if="form.cycle == null">
                          <v-switch
                          class="mt-0"
                          v-model="useCycleDates"
                          label="Usar fechas de ciclos"
                          dense hide-details
                          ></v-switch>
                        </v-container>
                      </v-col>
                    </v-row>
                    <v-row class="mt-0">
                      <v-expand-transition>
                        <v-col cols="12" class="pt-0" v-show="useCycleDates">
                          <v-card class="mx-1">
                            <v-card-text>
                              <div class="d-flex">
                                <v-icon color="blue darken-2" class="mr-4">mdi-information</v-icon>
                                <p class="mb-0 info--text">
                                  Si el ciclo del dispositivo no tiene rango de fecha parametrizado se usará el siguiente rango por defecto:
                                </p>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-expand-transition>
                      <v-col
                        class="colm_custom"
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-menu
                          v-model="datePicker1"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              ref="date-init"
                              v-model="dateIni"
                              label="Fecha Inicial"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense hide-details
                              required
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="date-init"
                            v-model="dateIni"
                            :max="new Date().toISOString().substr(0, 10)"
                            @input="datePicker1 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        class="colm_custom"
                        cols="12"
                        sm="12"
                        md="6"
                      >
                        <v-menu
                          v-model="datePicker2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              ref="date-dateEnd"
                              v-model="dateEnd"
                              label="Fecha Final"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense hide-details
                              required
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            ref="date-dateEnd"
                            v-model="dateEnd"
                            :min="new Date(dateIni).toISOString().substr(0, 10)"
                            :max="new Date().toISOString().substr(0, 10)"
                            @input="datePicker2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-autocomplete
                          ref="period"
                          v-model="form.period"
                          :items="periodSelect"
                          :search-input.sync="searchPeriod"
                          item-value="_id"
                          item-text="name"
                          label="Periodo"
                          placeholder="Selecciona el periodo"
                          :rules="nameRules"
                          clearable
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn large text @click.stop="show = false">Cerrar</v-btn>
              <v-btn
                v-if="stepReading == 1"
                :disabled="!valid"
                :loading="loadingCalculate"
                depressed
                large
                color="secondary"
                @click="calcular"
                >CALCULAR</v-btn
              >
              <v-btn
                v-if="stepReading == 2"
                :disabled="!valid2 || loadingReading"
                :loading="loadingReading"
                depressed
                large
                color="primary"
                @click="validate"
                >TOMAR LECTURA</v-btn
              >
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "TakeReadAllComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      form: {
        company: null,
        subTypeService: null,
        socialgroup: null,
        cycle: null,
        road: null,
        zone: null,
        period: null,
      },
      items: [],
      stepReading: 1,
      dateIni: moment().subtract(30,'days').format("YYYY-MM-DD"),
      dateEnd: moment().format("YYYY-MM-DD"),
      useCycleDates: true,
      valid: true,
      valid2: false, 
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => v != null || "El campo es requerido"],
      search: "",
      itemDevice: [],
      itemsCompany: [],
      searchSocial: "",
      itemsGroup: [],
      itemsZone: [],
      searchZone: "",
      itemsRoad: [],
      searchRoad: "",
      itemsCycle: [],
      searchCycle: "",
      itemsPeriod: [],
      searchPeriod: "",
      datePicker1: false,
      datePicker2: false,
      loadingCalculate: false,
      loadingReading: false,
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        this.stepReading = 1;
        this.$refs.form.reset();
        this.dateIni = moment().subtract(30,'days').format("YYYY-MM-DD");
        this.dateEnd = moment().format("YYYY-MM-DD");
        this.itemDevice = [];
        this.items = [];
        this.$emit("close");
      }
    });

    this.$root.$on("reload", async () => {
      if(this.$refs.form) {
        this.$refs.form.reset();
      }
      this.fillLists();
      this.$emit("close");
    });

    this.fillLists();
  },
  updated() {
    if(this.isMaster == 0) {
      this.form.company = this.itemsCompany[0];
    }
  },
  watch: {
    search: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonData();
      },
      deep: true,
    },
    searchSocial: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonSocial();
      },
      deep: true,
    },
    searchZone: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonZone();
      },
      deep: true,
    },
    searchRoad: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonRoad();
      },
      deep: true,
    },
    searchCycle: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonCycle();
      },
      deep: true,
    },
    searchPeriod: {
      handler(val) {
        if(val != null && val.length > 0) this.getJsonPeriod();
      },
      deep: true,
    },
    form: {
      handler(val) {
        if(this.stepReading == 1) {
          this.useCycleDates = val.cycle == null;
        }
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(["takeReadingAll", "alertSnackbar"]),
    clearLists() {
      this.$refs.zone.reset();
      this.$refs.cycle.reset();
      this.$refs.road.reset();
      this.$refs.social.reset();
      this.$refs.period.reset();
      this.fillLists();
		},

		async fillLists() {
			this.getJsonData();
			this.getJsonZone();
			this.getJsonCycle();
			this.getJsonRoad();
			this.getJsonSocial();
			this.getJsonPeriod();
		},

    validate() {
      if (this.$refs.form2.validate()) {
        this.registerForm();
      }
    },

    defaultDate() {
      if(this.form.cycle) {
        const cycle = this.cycleSelect.find(e => e._id == this.form.cycle);
        const today = new Date();
        let initDay = cycle.initDay;
        let endDay = cycle.endDay;
        const year = today.getFullYear();
        let endMonth = today.getMonth() + 1;
        if(endDay) {
          if(endDay > today.getDate()) {
            endMonth--;
          }
          let lastMonthDay = new Date(year, endMonth, 0);
          if(endDay > lastMonthDay.getDate()) {
            endDay = lastMonthDay.getDate();
          }
          const date = new Date(year, endMonth - 1, endDay);
          let day = date.getDate();
          let month = date.getMonth() + 1;
          day = (day < 10) ? '0' + day : day;
          month = (month < 10) ? '0' + month : month;
          this.dateEnd = date.getFullYear() + '-' + month + '-' + day;
        }
        if(initDay) {
          let initMonth = (Math.abs(initDay - endDay) > 27) ? endMonth : endMonth - 1;
          const date = new Date(year, initMonth - 1, initDay);
          let day = date.getDate();
          let month = date.getMonth() + 1;
          day = (day < 9) ? '0' + day : day;
          month = (month < 10) ? '0' + month : month;
          this.dateIni = date.getFullYear() + '-' + month + '-' + day;
        }
      }
    },

    async calcular() {
      if (this.$refs.form.validate()) {
        this.loadingCalculate = true;
        await this.getJsonDevice();
        this.loadingCalculate = false;
        if ((await this.DeviceNumber) <= 0) {
          this.alertSnackbar({
            snackbar: true,
            text: "Se debe tener 1 dispositivo para realizar la lectura masiva.",
          });
        } else {
          this.stepReading = 2;
        }
      }
    },
    async getJsonDevice() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          axios
            .post(`device/takelist`, this.form, {
              headers: headerToken,
            })
            .then((res) => {
              this.itemDevice = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonCycle() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany =
            this.form.company != null ? this.form.company._id : null;

          axios
            .get(
              `cycle/list?page=1&search=${this.searchCycle}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsCycle = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonPeriod() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany =
            this.form.company != null ? this.form.company._id : null;

          let urlQuery = 'period/list?page=1&onlyActive=true';
          if(this.searchPeriod != null) urlQuery += `&search=${this.searchPeriod}`;
          if(idCompany != null) urlQuery += `&company=${idCompany}`;

          axios
            .get(
              urlQuery,
              { headers: headerToken }
            )
            .then((res) => {
              this.itemsPeriod = res.data.docs,
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonRoad() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          // console.log('enviando', this.search)
          let idCompany =
            this.form.company != null ? this.form.company._id : null;
          axios
            .get(
              `road/list?page=1&search=${this.searchRoad}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsRoad = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonZone() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany =
            this.form.company != null ? this.form.company._id : null;
          axios
            .get(
              `zone/list?page=1&search=${this.searchZone}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsZone = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonSocial() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany =
            this.form.company != null ? this.form.company._id : null;
          axios
            .get(
              `socialgroup/list?page=1&search=${this.searchSocial}&company=${idCompany}`,
              {
                headers: headerToken,
              }
            )
            .then((res) => {
              this.itemsGroup = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async getJsonData() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };

          axios
            .get(`company/list?page=1&search=${this.search}`, {
              headers: headerToken,
            })
            .then((res) => {
              this.itemsCompany = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },
    async registerForm() {
      try {
        this.loadingReading = true;
        let devicesID = [];
        this.itemDevice.map((item) => {
          devicesID.push({
            device: item._id,
          });
        });
        let update = await this.takeReadingAll({
          devices: devicesID,
          period: this.form.period,
          initDate: this.dateIni,
          endDate: this.dateEnd,
          useCycleDates: this.useCycleDates,
        });
        this.$refs.form2.reset();
        this.itemDevice = [];
        this.items = [];
        if (update == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: "Se realizo la lectura masiva.",
          });
          this.$root.$emit("reload");
          this.$router.push({ name: "DeviceTakeResult" });
        }
        this.loadingReading = false;
        this.show = false;
      } catch (error) {
        this.loadingReading = false;
        this.alertSnackbar({
          snackbar: true,
          text: "ocurrio un error inesperado.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      'isMaster'
    ]),

    DeviceNumber() {
      return this.itemDevice.length;
    },

    socialSelect() {
      let filterSocial = this.itemsGroup
        .map((item) => {
          if (this.form.company != null) {
            if (typeof this.form.company != "object") {
              if (item.company._id === this.form.company) {
                return item;
              }
            } else {
              if (item.company._id === this.form.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterSocial;
    },
    zoneSelect() {
      let filterZone = this.itemsZone
        .map((item) => {
          if (this.form.company != null) {
            if (typeof this.form.company != "object") {
              if (item.company._id === this.form.company) {
                return item;
              }
            } else {
              if (item.company._id === this.form.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterZone;
    },
    cycleSelect() {
      let filterZone = this.itemsCycle
        .map((item) => {
          if (this.form.company != null) {
            if (typeof this.form.company != "object") {
              if (item.company._id === this.form.company) {
                return item;
              }
            } else {
              if (item.company._id === this.form.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterZone;
    },
    roadSelect() {
      let filterZone = this.itemsRoad
        .map((item) => {
          if (this.form.company != null) {
            if (typeof this.form.company != "object") {
              if (item.company._id === this.form.company) {
                return item;
              }
            } else {
              if (item.company._id === this.form.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterZone;
    },
    periodSelect() {
      let filterPeriod = this.itemsPeriod
        .map((item) => {
          if (this.form.company != null) {
            if (typeof this.form.company != "object") {
              if (item.company._id === this.form.company) {
                return item;
              }
            } else {
              if (item.company._id === this.form.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filterPeriod;
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.stepReading = 1;
          this.$refs.form.reset();
          this.dateIni = moment().subtract(30,'days').format("YYYY-MM-DD");
          this.dateEnd = moment().format("YYYY-MM-DD");
          this.itemDevice = [];
          this.items = [];
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
</style>
